import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Select, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelAfericaoDvec() {
  const [open, setOpen] = useState(true);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const status = [
    { label: t('s.relatorio.geral.todos'), value: 'null' },
    { label: t('s.geral.emafericao'), value: '1' },
    { label: t('s.geral.naocalculoufatork'), value: '2' },
    { label: t('s.geral.aguardandoatualizacaodvec'), value: '3' },
    { label: t('s.geral.atualizoudvec'), value: '4' },
    { label: t('s.geral.naoautalizoudvec'), value: '5' },
    { label: t('s.geral.dvecnaoatualizadocan'), value: '6' },
    { label: t('s.geral.primeiroabastecimento'), value: '7' },
    { label: t('s.geral.veiculocolocadoemmanutecao'), value: '8' },
    { label: t('s.geral.novodvecassociado'), value: '9' },
    { label: t('s.geral.naoaferiudvec'), value: '10' },
  ];

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsModelVehicle = useMemo(
    () => [
      {
        id: 'idmodeloveiculo',
        label: t('s.cadastro.modeloveiculo.codigoauxiliarmodeloveiculo'),
        filter: { type: 'text' },
      },
      /* {
        id: 'nomemarcaveiculo',
        label: t('s.cadastro.modeloveiculo.nomemarcaveiculo'),
        filter: { type: 'text' },
      }, */
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.modeloveiculo.nomemodeloveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    return {
      ...params,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.afericaodvec')}
      relatorio="afericaodvec"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        statusafericaodvec: 'null',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
      />

      <PesquisaTabela
        name="idmodeloveiculo"
        label={t('s.menu.cadastro.veiculo.modelo')}
        primary="idmodeloveiculo"
        secondary="nomemodelomarcamodeloveiculo"
        url="modelosveiculos"
        header={cellsModelVehicle}
      />

      <PesquisaTabela
        name="idveiculo"
        label={t('s.menu.cadastro.veiculo')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={cellsVehicle}
      />

      <Select
        name="statusafericaodvec"
        label={t('s.cadastro.veiculo.statusveiculo')}
        options={status}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelAfericaoDvec;
